import { ComponentMeta, ComponentStory } from "@storybook/react";
import React from "react";
import { action } from "@storybook/addon-actions";
import Pagination from "./Pagination";

type Story = ComponentStory<typeof Pagination>;

const commonArgs: React.ComponentProps<typeof Pagination> = {
    currentPage: 1,
    siblingsCount: 3,
    totalPages: 100,
    onPageChange: action("onPageChange"),
    trackName: "pagination"
};

export default {
    title: "common/Pagination",
    component: Pagination,
    args: commonArgs
} as ComponentMeta<typeof Pagination>;

const Template: Story = args => <Pagination {...args} />;

export const Start = Template.bind({});
Start.args = {
    currentPage: 1
};

export const InBetween = Template.bind({});
InBetween.args = {
    currentPage: 50
};

export const End = Template.bind({});
End.args = {
    currentPage: 100
};
